import AbonnementPage from '@/pages/AbonnementPage';

// ─────────────────────────────────────────────────────────────
// Choix / renouvellement de l'abonnement, DANS le dashboard.
// Réutilise le parcours de paiement complet (formules, moyens de
// paiement activés par le superadmin, FeexPay, Mobile Money…)
// sans quitter l'espace marchand.
// ─────────────────────────────────────────────────────────────

export default function DashboardChoisirAbonnementPage() {
  return (
    <div className="p-4 md:p-6">
      <AbonnementPage embedded />
    </div>
  );
}